// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1LsO7","item":"PaymentsMobile_item__3X4HX","label":"PaymentsMobile_label__2GDjJ","amount":"PaymentsMobile_amount__9klxY"};